import React, { useState } from 'react';
// Elements
import { CheckItem } from 'elements/ListItems';
import Tab from 'elements/Tabs/Tab';
// Config
import { userRoles } from './RolesMatrixConfig';
// Style
import styles from './style/rolesMatrix.module.css';

interface RoleProps {
  label: string,
  users: string[],
}

interface CategoryProps {
  id: string, 
  name: string,
  roles: RoleProps[],
}

function RolesMatrix() {
  const [activeRole, setActiveRole] = useState('Planning');

  function renderRole(role: RoleProps) {
    return (
      <li key={role.label}>
        <CheckItem
          borderInset={1}
          checked={role.users.includes(activeRole)}
          disabled
          label={role.label}
        />
      </li>
    )
  }

  function renderCategories(category:CategoryProps) {
    return (
      <div key={category.id}>
        {category.name && (
          <h6 className="subtitle1">{ category.name }</h6>
        )}
        <ul>
          {category.roles.map(renderRole)}
        </ul>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <div className={styles.tabs}>
        <Tab active={activeRole === 'Planning'} handler={() => (setActiveRole('Planning'))} label="Planning" />
        <Tab active={activeRole === 'Planning Admin'} handler={() => (setActiveRole('Planning Admin'))} label="Planning Admin" />
        <Tab active={activeRole === 'Master Data'} handler={() => (setActiveRole('Master Data'))} label="Master" />
        <Tab active={activeRole === 'Warehouse'} handler={() => (setActiveRole('Warehouse'))} label="Warehouse" />
      </div>
      <div className={styles.rolesList}>
        { userRoles.map(renderCategories)}
      </div>
    </div>
  );
}

export default RolesMatrix;
